import { css, Global } from '@emotion/react'
import { borderRadiusTokens, colorTokens } from './tokens'

const ToastStyles = () => (
  <Global
    styles={css`
      .Toastify__toast-container {
        z-index: 10000;
      }
      .Toastify__toast-container--bottom-right {
        bottom: 1rem;
        right: 1rem;
        left: auto !important;
      }
      .Toastify__toast {
        background-color: ${colorTokens.darkSlate};
        color:            ${colorTokens.white};
        border-radius:    ${borderRadiusTokens.control}px;
        padding:          14px 16px;
        font-style:       normal;
        font-size:        0.875rem;
        font-weight:      400;
        box-shadow:       0 4px 12px rgba(0, 0, 0, 0.15);
      }
      .Toastify__toast--success {
        background-color: ${colorTokens.green200};
        color:            ${colorTokens.white};
        border-left:      3px solid ${colorTokens.green100};
      }
      .Toastify__toast--error {
        background-color: ${colorTokens.errorDark};
        color:            ${colorTokens.white};
        border-left:      3px solid ${colorTokens.errorMain};
      }
      .Toastify__toast--info {
        background-color: ${colorTokens.blueHeader};
        color:            ${colorTokens.white};
      }
      .Toastify__progress-bar {
        background-color: rgba(255, 255, 255, 0.4);
      }
      .Toastify__close-button {
        color:   ${colorTokens.white};
        opacity: 0.7;
      }
      .Toastify__close-button:hover {
        opacity: 1;
      }
    `}
  />
)

export default ToastStyles
